export default __webpack_public_path__ + "static/media/9.1740ddf0.JPG";